import React from 'react';

import { useNavigate } from 'react-router';

import { MainMenuLink } from 'components/main-menu-link';
import { useWindowDimensions } from 'hooks/use-window-dimensions';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useMenuContext } from 'state/menu';
import { useProductWizardContext } from 'state/product-wizard';
import { ProductWizardStep } from 'state/product-wizard/types';

import { ProductLayout } from './product-layout/product-layout';
import { LayoutContainer, LayoutContent } from './styled';

export const ProductDetail: React.FC = () => {
  const navigate = useNavigate();

  const { currentStep } = useProductWizardContext();
  const { showStaticMenu } = useMenuContext();
  const useEnableShowPickerAspectsInStaticMenu = useFlag(
    LaunchDarklyFlag.ENABLE_SHOW_PICKER_ASPECTS_IN_STATIC_MENU
  );

  // Product customization has its own back button
  const showBackButton = currentStep !== ProductWizardStep.ProductCustomization;

  const { height: windowHeight } = useWindowDimensions();

  const handleBackButtonClick = () => {
    navigate(-1);
  };
  // switch to <main></main> when imported from layout
  return (
    <LayoutContainer
      $isStatic={showStaticMenu && !useEnableShowPickerAspectsInStaticMenu}
      data-testid="product-detail"
    >
      <MainMenuLink onClick={handleBackButtonClick} />
      <LayoutContent
        $windowHeight={windowHeight}
        isStoreSelected={showStaticMenu && !useEnableShowPickerAspectsInStaticMenu}
      >
        <ProductLayout showBackButton={showBackButton} />
      </LayoutContent>
    </LayoutContainer>
  );
};
